import React, { useState } from "react";
import emailjs from "emailjs-com";
const ContactUs = () => {
  // State to handle the expandable div
  // const [expand, setExpand] = useState(false);
  const backgroundImage = process.env.PUBLIC_URL + "/CurveContactUs.svg";
  const [expand1, setExpand1] = useState(false);
  const [expand2, setExpand2] = useState(false);
  const [expand3, setExpand3] = useState(false);
  const [expand4, setExpand4] = useState(false);
  const [expand5, setExpand5] = useState(false);
  const [expand6, setExpand6] = useState(false);

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic (Czechia)",
    "Democratic Republic of the Congo (Congo-Kinshasa)",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor (Timor-Leste)",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast (Côte d'Ivoire)",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "São Tomé and Príncipe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City (Holy See)",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  // State to store form values
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    country: "India", // Default to India
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [loading, setLoading] = useState(false); // State to manage loading status

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const templateParams = {
      message: JSON.stringify(formData),
    };
    if (loading) {
      return;
    }

    emailjs
      .send(
        "service_p75x8yg",
        "template_o3lsuon",
        templateParams,
        "bybF36Fy2yFIoVwDm"
      )
      .then(
        (result) => {
          alert("Submitted Successfully!!");
          setLoading(false); // Reset loading state
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
            country: "India", // Reset to default country
          });
        },
        (error) => {
          alert("Error occured. Pls contact customer care at +919445202342");
          setLoading(false); // Reset loading state
        }
      );
  };

  return (
    <div className="font-poppins pt-20">
      {/* Quote Rows */}
      <div className="text-center py-2  mt-6    font-semibold">
        Lets have a chat
      </div>
      <div className="text-center py-2 mb-0 text-xl font-semibold">
        An expert at your services
      </div>
      {/* Flexbox with 3 columns */}
      <div
        className="w-full flex justify-between mt-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="w-1/4 p-2 hidden md:block"></div>

        {/* Column 2 - Form */}
        <div className="w-full md:w-2/4 p-10">
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-poppins font-bold mb-0 text-gray-700"
              >
                Name
              </label>
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full p-3 mt-0 rounded-2xl border border-black"
                required
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-poppins font-bold mb-0 text-gray-700"
              >
                Email Address
              </label>
              <input
                required
                type="email"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full p-3 rounded-2xl border border-black"
              />
            </div>
            <div>
              <label
                htmlFor="country"
                className="block text-sm font-poppins font-bold mb-0 text-gray-700"
              >
                Country
              </label>
              <select
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                className="w-full p-3 rounded-2xl border border-black"
              >
                {countries.map((country, index) => (
                  <option key={index} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-poppins font-bold mb-0 text-gray-700"
              >
                Phone Number
              </label>
              <input
                required
                type="number"
                placeholder="Phone Number"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className="w-full p-3 rounded-2xl border border-black"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-poppins font-bold mb-0 text-gray-700"
              >
                Message
              </label>
              <textarea
                required
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full p-3 rounded-2xl border border-black"
              />
            </div>
            <div className="flex justify-center">
              <button
                type="submit"
                className="w-[50%] md:w-[60%] lg:1/3 p-3 bg-[#1E1A18] text-white font-semibold rounded-full active:animate-bounce flex justify-center items-center"
              >
                {loading ? "Sending..." : "Send Message"}{" "}
                {/* Show loading text */}
                <span className="ml-2">{loading ? "" : ">"}</span>
              </button>
            </div>
          </form>
        </div>

        {/* Column 3 - 25% */}
        <div className="w-1/4 p-4 hidden md:block"></div>
      </div>

      {/* Flexbox for FAQ Section *}
      
      
        {/* Left Column with Q&A */}
      <div className="md:flex justify-between mt-4 p-9 bg-[#F6F4F2]">
        <div className="w-full md:w-1/2 p-3 md:p-6">
          <h3 className="text-3xl text-[#E8563F] font-semibold mb-4">
            Frequently Asked Questions
          </h3>
          <p className="pt-4 text-lg">
            We receive many messages with similar questions, so here are quick
            answers to some of our most frequently asked questions.
          </p>
        </div>

        {/* Right Column with Expandable Content */}
        <div className="w-full md:w-1/2 p-3 md:p-8">
          {/* First Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand1(!expand1)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                What fabric types and garment styles do you specialize in?
              </p>
              <span
                className={`transition-transform duration-300 text-black ${
                  expand1 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand1 ? "−" : "✚"}
              </span>
            </div>
            {expand1 && (
              <div className="mt-4">
                <p>
                  We specialize in processing various types of knitted fabrics,
                  including cotton, polyester, blends, and sustainable fabrics.
                  Our expertise includes a wide range of garment styles, from
                  casual wear to performance and technical garments.
                </p>
              </div>
            )}
          </div>

          {/* Second Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand2(!expand2)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                Do you provide end-to-end services from fabric processing to
                finished garment production?
              </p>
              <span
                className={`transition-transform  duration-300 text-black ${
                  expand2 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand2 ? "−" : "✚"}
              </span>
            </div>
            {expand2 && (
              <div className="mt-4">
                <p>
                  Yes, we offer end-to-end services, covering fabric processing,
                  garment manufacturing, quality control, and sustainable
                  finishing. This ensures consistent quality throughout each
                  stage of production.
                </p>
              </div>
            )}
          </div>
          {/* Second Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand3(!expand3)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                Can I track my order progress and receive updates on its status?
              </p>
              <span
                className={`transition-transform duration-300 text-black ${
                  expand3 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand3 ? "−" : "✚"}
              </span>
            </div>
            {expand3 && (
              <div className="mt-4">
                <p>
                  Absolutely. We offer regular updates and tracking options to
                  keep you informed on the progress of your fabric processing or
                  garment manufacturing order, ensuring transparency and
                  reliability.
                </p>
              </div>
            )}
          </div>
          {/* Second Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand6(!expand6)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                Can I discuss my specific project needs directly with a
                technical expert?
              </p>
              <span
                className={`transition-transform duration-300 text-black ${
                  expand6 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand6 ? "−" : "✚"}
              </span>
            </div>
            {expand6 && (
              <div className="mt-4">
                <p>
                  Certainly. Our technical experts are available to discuss your
                  unique requirements, guide you on the best processing
                  techniques, and provide expert advice to ensure your project’s
                  success.
                </p>
              </div>
            )}
          </div>
          {/* Second Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand4(!expand4)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                Do you offer sustainable or eco-friendly fabric processing
                options?
              </p>
              <span
                className={`transition-transform duration-300 text-black ${
                  expand4 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand4 ? "−" : "✚"}
              </span>
            </div>
            {expand4 && (
              <div className="mt-4">
                <p>
                  Yes, sustainability is a priority for us. We use an in-house
                  water treatment system, including a Zero Liquid Discharge
                  (ZLD) setup, to ensure minimal environmental impact.
                </p>
              </div>
            )}
          </div>
          {/* Second Expandable Item */}
          <div
            className="p-4 border border-black bg-white rounded cursor-pointer hover:bg-gray-100 transition mb-4"
            onClick={() => setExpand5(!expand5)}
          >
            <div className="flex justify-between items-center">
              <p className="font-bold">
                What type of customization options do you provide?
              </p>
              <span
                className={`transition-transform duration-300 text-black ${
                  expand5 ? "rotate-180" : "rotate-0"
                }`}
              >
                {expand5 ? "−" : "✚"}
              </span>
            </div>
            {expand5 && (
              <div className="mt-4">
                <p>
                  We offer various customization options, including fabric
                  finishes, garment styles, and sustainable processing
                  techniques. Please provide your specifications to explore
                  options tailored to your needs.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div class=" h-10">
        <div className="w-[30%] ">
          <a href="/" className="  ">
            <img
              src="/DotsContactUs.svg"
              alt="Logo"
              className="-mt-4 md:-mt-6 lg:-mt-8 "
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
